import {
  CoachingChannel,
  CoachingDrillResult,
  CoachingEnding,
  CoachingRelationshipStage,
} from '@euler/model/coaching';
import {
  CoachingAnchor,
  CoachingCustomerMood,
} from '@euler/model/coaching-practice';
import { aiColors } from '../../ai-suite/theme';
import { channelName } from '../copy';

export const kMoodLabels: Record<CoachingCustomerMood, string> = {
  [CoachingCustomerMood.Impatient]: '不耐烦了',
  [CoachingCustomerMood.Guarded]: '有点戒备',
  [CoachingCustomerMood.Hesitant]: '有点犹豫',
  [CoachingCustomerMood.Open]: '愿意听听',
  [CoachingCustomerMood.Reassured]: '放心了',
};

/** Cool when guarded, warm when reassured. */
export const kMoodColors: Record<CoachingCustomerMood, string> = {
  [CoachingCustomerMood.Impatient]: aiColors.red,
  [CoachingCustomerMood.Guarded]: aiColors.violet,
  [CoachingCustomerMood.Hesitant]: aiColors.amber,
  [CoachingCustomerMood.Open]: aiColors.blue,
  [CoachingCustomerMood.Reassured]: aiColors.green,
};

export const kStageLabels: Record<CoachingRelationshipStage, string> = {
  [CoachingRelationshipStage.Prospective]: '潜在客户',
  [CoachingRelationshipStage.FirstTime]: '首次到店',
  [CoachingRelationshipStage.Active]: '老客户',
  [CoachingRelationshipStage.AtRisk]: '有流失风险',
  [CoachingRelationshipStage.Inactive]: '久未到店',
  [CoachingRelationshipStage.Returning]: '回流客户',
};

export const kEndingLabels: Record<CoachingEnding, string> = {
  [CoachingEnding.Purchase]: '同意购买',
  [CoachingEnding.WorkAuthorized]: '同意施工',
  [CoachingEnding.Booking]: '约好到店',
  [CoachingEnding.FurtherAssessment]: '先进一步检测',
  [CoachingEnding.AgreedFollowUp]: '约好再联系',
  [CoachingEnding.InformedRefusal]: '了解后拒绝',
  [CoachingEnding.Resolution]: '达成解决',
  [CoachingEnding.Escalation]: '转交处理',
  [CoachingEnding.NoFurtherContact]: '不再联系',
  [CoachingEnding.CustomerLeft]: '客户离开',
  [CoachingEnding.Undecided]: '未决定',
};

export const kDrillResultLabels: Record<CoachingDrillResult, string> = {
  [CoachingDrillResult.Demonstrated]: '做到了',
  [CoachingDrillResult.PartiallyDemonstrated]: '部分做到',
  [CoachingDrillResult.Missed]: '没做到',
  [CoachingDrillResult.CriticalError]: '关键失误',
  [CoachingDrillResult.TurnLimitReached]: '回合用完',
};

export const kAnchorLabels: Record<CoachingAnchor, string> = {
  [CoachingAnchor.Strong]: '到位',
  [CoachingAnchor.Partial]: '部分到位',
  [CoachingAnchor.Poor]: '没做到',
};

export const kAnchorColors: Record<CoachingAnchor, string> = {
  [CoachingAnchor.Strong]: aiColors.green,
  [CoachingAnchor.Partial]: aiColors.amber,
  [CoachingAnchor.Poor]: aiColors.red,
};

/** The pill over a conversation: where it happens and who spoke first. */
export function scenePillText(
  channel: CoachingChannel,
  /** 你 or the customer's name; null when that is beside the point. */
  opener: string | null,
): string {
  return opener
    ? `${channelName(channel)} · ${opener}先开口`
    : channelName(channel);
}
